export default "__VITE_ASSET__BrsXTplN__"